import { localStore } from 'mutants-microfx';
import { clientInfoKey } from '../const/app';
var ClientInfo = /** @class */ (function () {
    function ClientInfo(osRelease, networkStatus, manufacturer, model) {
        this.osRelease = osRelease;
        this.networkStatus = networkStatus;
        this.manufacturer = manufacturer;
        this.model = model;
    }
    ClientInfo.getClientInfo = function (deviceInfo) {
        var clientInfo = new ClientInfo(deviceInfo.osRelease, deviceInfo.networkStatus, deviceInfo.manufacturer, deviceInfo.model);
        return clientInfo;
    };
    //缓存数据
    ClientInfo.prototype.cache = function () {
        localStore.set(clientInfoKey, this);
    };
    //从缓存中恢复ClientInfo对象
    ClientInfo.restore = function () {
        var clientInfo = localStore.get(clientInfoKey);
        if (clientInfo) {
            return clientInfo;
        }
        return undefined;
    };
    return ClientInfo;
}());
export default ClientInfo;

//# sourceMappingURL=ClientInfo.js.map
